import { Controller } from "@hotwired/stimulus"

// Panneau « Ajouter un champ » : la recherche recharge la liste des champs de la banque, les champs
// proches déjà présents et la proposition « Créer le champ ».
export default class extends Controller {
  static targets = ["query", "results"]
  static values = { url: String }

  disconnect() { clearTimeout(this.timer) }

  search() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.resultsTarget.src = `${this.urlValue}?${new URLSearchParams({ q: this.queryTarget.value.trim() })}`
    }, 200)
  }
}
